import React, { useEffect, useState } from "react";
import styles from "../../styles/Select.module.css";

interface InputProps {
  label: string;
  value: string | number | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  type?: "text" | "number" | "password" | "email";
  placeholder?: string;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  placeholderColor?: string;
  labelStyle?: React.CSSProperties;
  error?: string;
  isLabelFloating?: boolean;
  maxNumber?: number
}

export const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  disabled,
  type = "text",
  placeholder,
  style,
  inputStyle,
  labelStyle,
  error,
  isLabelFloating,
  maxNumber
}) => {
  const [focused, setFocused] = useState(false);
  const [localError, setLocalError] = useState(error);
  const hasValue = value !== undefined && value !== "";
  const isFloating = isLabelFloating ? isLabelFloating : focused || hasValue;
  const defaultPlaceholder =
    type === "number" ? "Введіть число " : "Введіть данні ";
  const resolvedPlaceholder = placeholder ?? defaultPlaceholder;

  useEffect(() => {
    setLocalError(error);
  }, [error]);

  const handleChange = (val: string) => {
    setLocalError(undefined);
    onChange(val);
  };
  return (
    <div className={styles.formControl} style={style}>
      <div className={styles.selectWrapper}>
        <input
          type={type}
          maxLength={40}
          onInput={(e: React.FormEvent<HTMLInputElement>) => {
            if (type === "number") {
              const target = e.currentTarget;
              const max = maxNumber ?? 20; 
              if (target.value.length > max) {
                target.value = target.value.slice(0, max);
              }
            }
          }}
          className={styles.select}
          value={value ?? ""}
          disabled={disabled}
          placeholder={isFloating ? resolvedPlaceholder : ""}
          onChange={(e) => handleChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            ...inputStyle,
            borderColor: error ? "var(--vivid-pink)" : undefined,
            width: "100%",
            paddingRight: type === "number" ? "40px" : "12px",
          }}
        />
        {type === "number" && (
          <span
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
              fontSize: "11px",
              fontWeight: 700,
              color: focused ? "var(--blue)" : "var(--disabled-c)",
              letterSpacing: "-0.5px",
              transition: "color 0.2s",
            }}
          >
            123
          </span>
        )}

        <label
          style={{
            position: "absolute",
            left: "10px",
            top: isFloating ? "-8px" : "50%",
            transform: isFloating ? "translateY(0)" : "translateY(-50%)",
            padding: "0 4px",
            fontSize: isFloating ? "12px" : "14px",
            color: focused ? "var(--blue)" : "var(--black)",
            background: isFloating
              ? "linear-gradient(to bottom, var(--background) 40%, white 60%)"
              : "transparent",

            pointerEvents: "none",
            zIndex: 1,
            fontWeight: isFloating ? 700 : 500,
            transition:
              "top 0.2s ease, font-size 0.2s ease, color 0.2s ease, transform 0.2s ease",
            whiteSpace: "nowrap",
            ...labelStyle,
          }}
        >
          {label}
        </label>
      </div>

      <div
        style={{
          color: "var(--vivid-pink)",
          fontSize: "11px",
          // marginTop: "4px",
          paddingLeft: "4px",
          height: "16px",
        }}
      >
        {localError ? localError : null}
      </div>
    </div>
  );
};
